import { IMediaAndContent } from "../../interfaces/MediaAndContent"
import { API_FILES_BASE_URL } from "../../utils/const";
import DateWithIcon from "../Common/DateWithIcon";

type MediaAndTextProps = Pick<IMediaAndContent, 'imagen' | 'titulo' | 'texto' | 'fecha'> & {
    bg?: string
}

const MediaAndText = ({ imagen, titulo, texto, fecha, bg = 'transparent' }: MediaAndTextProps) => {
    return (
        <div className="flex flex-col md:flex-row w-full max-w-[20.5rem] md:max-w-[32.875rem] h-[43.385rem] md:h-full">
            <img
                src={`${API_FILES_BASE_URL}${imagen.replace("files/", "")}`}
                alt={imagen.replace("files/", "")}
                className='w-full  max-w-[20.5rem] h-full max-h-[29.01rem] md:w-[14rem] md:h-[19.8125rem] rounded-t-sm md:rounded-tr-none md:rounded-l-sm object-cover object-center'
            />
            <div className={`${bg} h-full p-6 rounded-b-sm md:rounded-bl-none md:rounded-r-sm flex-1`}>
                <h2 className="text-tintermedium text-primary-100">{titulo}</h2>
                <p className="text-bsmall text-primary-100 py-2 min-h-[6rem]">{texto}</p>
                <DateWithIcon
                    date={fecha}
                    color='text-primary-100'
                />
            </div>
        </div>
    )
}

export default MediaAndText